import React from 'react';
import { useMatch } from 'react-router-dom';
import styled from 'styled-components';
import { Button, TrevorComponent } from '@trevor/ui-components';
import { SETUP_URL_PATH } from '@/routing/paths';
import { TrevorLink } from '@/components/TrevorLink';

const _BackToDatasourcesButton: TrevorComponent = ({ className }) => {
  const isCredentialsSetupView = !!useMatch(SETUP_URL_PATH);

  if (isCredentialsSetupView) return null;

  return (
    <div className={className}>
      <TrevorLink to="/datasources">
        <Button variant="secondary">Back to datasources</Button>
      </TrevorLink>
    </div>
  );
};

export const BackToDatasourcesButton = styled(_BackToDatasourcesButton)`
  position: absolute;
  top: 20px;
  left: 20px;

  ${TrevorLink} {
    text-decoration: none;
  }
`;
